/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const BillingSettingsPricePlan = {
    ESSENTIAL: 'ESSENTIAL',
    ESSENTIAL_MYNT_SE: 'ESSENTIAL_MYNT_SE',
    PREMIUM: 'PREMIUM',
    EXTERNAL: 'EXTERNAL',
    ESSENTIAL_2026_MYNT_SE: 'ESSENTIAL_2026_MYNT_SE',
    ESSENTIAL_2026_MYNT_FI: 'ESSENTIAL_2026_MYNT_FI',
    ESSENTIAL_2026_MYNT_NO: 'ESSENTIAL_2026_MYNT_NO',
    ESSENTIAL_2026_MYNT_SE_TIER_1: 'ESSENTIAL_2026_MYNT_SE_TIER_1',
    ESSENTIAL_2026_MYNT_SE_TIER_2: 'ESSENTIAL_2026_MYNT_SE_TIER_2',
    ESSENTIAL_2026_MYNT_SE_TIER_SPECIAL: 'ESSENTIAL_2026_MYNT_SE_TIER_SPECIAL',
    PREMIUM_2026_MYNT_SE: 'PREMIUM_2026_MYNT_SE',
    PREMIUM_2026_MYNT_FI: 'PREMIUM_2026_MYNT_FI',
    PREMIUM_2026_MYNT_NO: 'PREMIUM_2026_MYNT_NO',
    PREMIUM_2026_MYNT_SE_TIERED: 'PREMIUM_2026_MYNT_SE_TIERED',
    PREMIUM_2026_MYNT_SE_TIER_SPECIAL: 'PREMIUM_2026_MYNT_SE_TIER_SPECIAL'
} as const;

export type BillingSettingsPricePlan = typeof BillingSettingsPricePlan[keyof typeof BillingSettingsPricePlan];



